// Import and register all your controllers from the importmap under controllers/*

import { application } from "common/stimulus_application"
import { registerCommonControllers } from 'controllers'

registerCommonControllers(application)
